(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const reveal = () => {
    observer?.disconnect();
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('od-revealed');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-od-reveal]:not(.od-revealed)').forEach(element => observer.observe(element));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal, { once: true });
  else reveal();
  document.addEventListener('shopify:section:load', reveal);
  reducedMotion.addEventListener('change', () => {
    observer?.disconnect();
    document.querySelectorAll('.od-revealed').forEach(element => element.classList.remove('od-revealed'));
    reveal();
  });
})();
